import uuid from "uuid/v4";

import {
  CreateVocabularyInput,
  ModelGetInput,
  UpdateVocabularyInput,
  Vocabulary,
} from "@examspark/types";

import { GraphQLAPI } from "../client";

export const _getVocabulary = /* GraphQL */ `
  query GetVocabulary($input: ModelGetInput!) {
    getVocabulary(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      createdAt
      description
      grade
      language
      isDeleted
      name
      subject
      tags {
        key
        value
      }
      updatedAt
    }
  }
`;

const _getVocabularyWithUsages = /* GraphQL */ `
  query GetVocabularyWithUsages($input: ModelGetInput!) {
    getVocabulary(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      createdAt
      description
      grade
      language
      isDeleted
      name
      subject
      usages {
        count
        items {
          id
          sk
          tags {
            key
            value
            type
          }
          item {
            name
          }
        }
      }
      tags {
        key
        value
      }
      updatedAt
    }
  }
`;

const _createVocabulary = /* GraphQL */ `
  mutation CreateVocabulary($input: CreateVocabularyInput!) {
    createVocabulary(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      createdAt
      description
      grade
      isDeleted
      name
      subject
      updatedAt
    }
  }
`;

const _updateVocabulary = /* GraphQL */ `
  mutation UpdateVocabulary($input: UpdateVocabularyInput!) {
    updateVocabulary(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      createdAt
      description
      grade
      isDeleted
      name
      subject
      updatedAt
    }
  }
`;

type ProvidedCreateInputFields = "id" | "sk" | "schemaVersion";
type ProvidedUpdateInputFields = "sk";

export const createVocabulary = async (
  data: Omit<CreateVocabularyInput, ProvidedCreateInputFields>,
) => {
  const result = await GraphQLAPI.client.query<{
    createVocabulary: Vocabulary;
  }>({
    query: _createVocabulary,
    variables: {
      input: {
        id: uuid(),
        sk: "vocabulary",
        schemaVersion: "2020-01-01",
        ...data,
      } satisfies CreateVocabularyInput,
    },
  });

  return result.data?.createVocabulary;
};

export const updateVocabulary = async (
  data: Omit<UpdateVocabularyInput, ProvidedUpdateInputFields>,
) => {
  const result = await GraphQLAPI.client.query<{
    createVocabulary: Vocabulary;
  }>({
    query: _updateVocabulary,
    variables: {
      input: {
        ...data,
        sk: "vocabulary",
      } satisfies UpdateVocabularyInput,
    },
  });

  return result.data?.createVocabulary;
};

export const getVocabulary = async (id: string) => {
  const result = await GraphQLAPI.client.query<{
    getVocabulary: Vocabulary;
  }>({
    query: _getVocabulary,
    variables: {
      input: {
        id: id,
        sk: "vocabulary",
      } satisfies ModelGetInput,
    },
  });

  return result.data?.getVocabulary;
};

export const getVocabularyWithUsages = async (id: string) => {
  const result = await GraphQLAPI.client.query<{
    getVocabulary: Vocabulary;
  }>({
    query: _getVocabularyWithUsages,
    variables: {
      input: {
        id: id,
        sk: "vocabulary",
      } satisfies ModelGetInput,
    },
  });

  return result.data?.getVocabulary;
};
